<template>
    <div class="courseDirection">
        <div class="box">
            <header>学员专属课程</header>

            <div class="direction">
                <a-row type="flex" justify="center" :gutter="{ xs: 16, sm: 32, md: 48, lg: 64,xl:112,xxl:128 }">
                    <!--                    <div >-->
                    <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8"
                           class="direction-list" v-for="(item,value) in courseDirection"
                           @click="tolearningDirectionDetail(item.directionId)" :key=value
                    >
                            <ul class="hover-img-scale-box">
                                <li class="direction-cover hover-img-scale-box"><img :src=item.coverImgUrl alt=""></li>
                                <li class="title">{{item.directionTitle}}</li>
                                <li><p :title="item.directionDesc">
                                    {{item.directionDesc}}
                                </p></li>
                            </ul>
                        </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
    import {showError, showSuccessMsg} from "@utils/msg";
    import {learningDirection, learningDirectionDetail} from "@api/courseDirection-api"

    export default {
        name: "courseDirection",
        data() {
            return {
                courseDirection: []
            }
        },
        created() {
            learningDirection().then((res) => {
                this.courseDirection = res.rows
            })
        },
        methods: {
            tolearningDirectionDetail(directionId) {
                learningDirectionDetail(directionId).then((res) => {
                    if (res.code === 0) {
                        if (res.canStudyDirection) {
                            //    跳转到学院专属课程详情
                            showSuccessMsg("您已购买该方向课程，快开始学习吧！");

                            this.$router.push({
                                path: "/other/course-direction-detail",
                                query: {
                                    directionId: directionId
                                }
                            })

                        } else {
                            this.$router.push({
                                path: res.learningDirection.jumpUrl,
                                query: {
                                    directionId: directionId
                                }
                            })
                        }
                    } else {
                        showError("获取学习方向出错", res.msg)
                    }
                })
            }
        }
    }
</script>

<style scoped lang="less">
    courseDirection {

    }

    .box {
        /*width: 100%;*/
        padding: 20px;
        /*max-width: 1400px;*/
        /*margin: auto;*/

        header {
            color: #333333;
            margin: 30px 0 80px;
            font-size: 20px;
            text-align: center;
        }

        .direction {
            ul {
                border: 1px solid #D9D9D9;
                margin-bottom: 50px;
            }

            ul:hover {
                cursor: pointer;
                color: #00CF8C;
            }

            li {
                img {
                    display: block;
                    /*width: 386px;*/
                    width: 100%;
                    height: 190px;
                }

                p {
                    height: 55px;
                    padding: 0 20px 20px 20px;
                    color: #999999;
                    font-size: 12px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                }
            }

            .title {
                /*padding: 4px 20px;*/
                font-size: 18px;
                margin: 16px 20px;
            }

            .title:hover {
                color: #00CF8C;
            }
        }

        .direction-list {
            cursor: pointer;
        }
    }

    .direction-cover {
        overflow: hidden;
    }

    @import "../../styles/variable.less";

    // 最大宽度小于 sm
    @media screen and (max-width: @screen-md) {
        .box {
            width: 80%;
            padding: 10px;
        }
    }

    @media screen and (min-width: @screen-md) {
        .box {
            width: 750px;
            margin: auto;
        }
    }

    @media screen and (min-width: @screen-lg) {
        .box {
            width: 970px;
            margin: auto;
        }
    }

    @media screen and (min-width: @screen-xl) {
        .box {
            width: 1170px;
            margin: auto;
        }
    }

    @media screen and (min-width: @screen-xxl) {
        .box {
            width: 1170px;
            margin: auto;
        }
    }


</style>
